import { Contraparte } from "../contraparte";

export enum ContraparteContatoTipo {
  MESA = "Mesa",
  BACKOFFICE = "Backoffice",
  FINANCEIRO = "Financeiro",
  JURIDICO = "Juridico",
  OUTRO = "Outros",
}

export interface ContraparteContato {
  readonly id?: number | null;
  readonly contraparte?: Contraparte | null;
  readonly nome?: string | null;
  readonly email?: string | null;
  readonly telefone?: string | null;
  readonly celular?: string | null;
  readonly tipo?: string | null;
}
